import { defineInterface } from '@nzyme/ioc/Interface.js';
import * as z from 'zod/mini';
export const AuthState = z.object({
    accessToken: z.string(),
    idToken: z.string(),
    refreshToken: z.nullish(z.string()),
});
export const AuthStore = defineInterface({
    name: 'AuthStore',
});
//# sourceMappingURL=AuthStore.js.map